import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { useSelector } from "react-redux";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  interaction: {
    mode: "index",
    intersect: false,
  },
  stacked: false,
  //   plugins: {
  //     title: {
  //       display: true,
  //       text: "Approved Sender Id Types",
  //     },
  //   },
  scales: {
    y: {
      type: "linear",
      display: true,
      position: "left",
    },
    y1: {
      type: "linear",
      display: true,
      position: "right",
      grid: {
        drawOnChartArea: false,
      },
    },
  },
};

const labels = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
];

export const data = {
  labels,
  datasets: [
    {
      label: "Pending for Approval",
      data: [65, 29, 80, 31, 56, 39, 41, 65, 22, 89, 81],
      borderColor: "#39CCCC",
      // backgroundColor: "rgb(0,0,135)",
      backgroundColor: "#39CCCC",
      yAxisID: "y",
      tension: 0.5,
    },
    {
      label: "Active",
      data: [76, 29, 92, 61, 60, 52, 46, 87, 59, 90, 81],
      borderColor: "#D81B60",
      // backgroundColor: "rgb(117,217,239)",
      backgroundColor: "#D81B60",
      yAxisID: "y1",
      tension: 0.5,
    },
    {
      label: "In Process",
      data: [50, 17, 60, 44, 26, 14, 29, 15, 59, 89, 51],
      borderColor: "#FF851B",
      // backgroundColor: "rgb(80,108,120)",
      backgroundColor: "#FF851B",
      yAxisID: "y1",
      tension: 0.5,
    },
    {
      label: "Rejected",
      data: [10, 9, 37, 41, 21, 28, 11, 35, 24, 67, 61],
      borderColor: "#605CA8)",
      // backgroundColor: "rgb(216,217,221)",
      backgroundColor: "#605CA8",
      yAxisID: "y1",
      tension: 0.5,
    },
  ],
};

export function MultiLineGraph({ value: localData }) {
  const globalData = useSelector((state) => state.dashboardReducer);

  return <Line options={options} data={data} />;
}
